import React, { createContext, useContext } from 'react';

const ModalStackContext = createContext(0);

export const MODAL_Z_BASE = 50;
export const MODAL_Z_STEP = 30;

export function ModalStackProvider({ children }) {
  return <ModalStackContext.Provider value={0}>{children}</ModalStackContext.Provider>;
}

export function useModalStackDepth() {
  return useContext(ModalStackContext);
}

export function useModalZIndex() {
  const depth = useModalStackDepth();
  return MODAL_Z_BASE + depth * MODAL_Z_STEP;
}

/** Wrap modal contents so any child modal gets a higher stack layer. */
export function ModalStackIncrement({ children }) {
  const depth = useModalStackDepth();
  return <ModalStackContext.Provider value={depth + 1}>{children}</ModalStackContext.Provider>;
}
